import { bonusAgents } from '../../../mocks/courses';

export default function BonusSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 text-amber-700 text-sm font-semibold rounded-full mb-4">
            <i className="ri-star-fill w-4 h-4 flex items-center justify-center"></i>
            Bônus Exclusivos
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            3 Agentes de IA Inclusos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Assistentes inteligentes criados especialmente para professores brasileiros, prontos para usar no seu dia a dia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {bonusAgents.map((agent) => (
            <div
              key={agent.id}
              className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-amber-200 hover:border-amber-400 transition-all duration-300 hover:shadow-2xl group"
            >
              <div className="relative">
                <div className="w-full h-64 overflow-hidden">
                  <img
                    src={agent.image}
                    alt={agent.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <span className="absolute top-4 left-4 px-3 py-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-bold rounded-full flex items-center gap-1.5 shadow-lg">
                  <i className="ri-gift-fill"></i>
                  {agent.badge}
                </span>
              </div>
              <div className="p-8">
                <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center mb-4">
                  <i className={`${agent.icon} text-amber-600 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {agent.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  {agent.description}
                </p>
                <div className="flex items-center gap-2 text-amber-600 text-sm font-semibold">
                  <i className="ri-infinity-line w-4 h-4 flex items-center justify-center"></i>
                  Acesso ilimitado incluso no curso
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
